<template lang="html">
  <div class="change-password-form">
    <v-form ref="form" v-model="formIsValid" @submit.prevent @keypress.enter.native="submit">
      <password-field
        v-model="password"
        :label="$t('changePassword.newPassword')"
        :rules="validationRules.password"
        :placeholder="$t('changePassword.newPassword.placeholder')"
      ></password-field>

      <div class="d-flex justify-center">
        <v-btn class="submit" color="primary" :disabled="!formIsValid || submited" :loading="submited" @click="submit">
          {{ $t('submit') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import PasswordField from '@/components/common/PasswordField.vue';

export default {
  name: 'ChangePasswordForm',
  components: {
    PasswordField,
  },
  props: {
    submited: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formIsValid: false,
      password: null,
      showPassword: false,
    };
  },
  computed: {
    validationRules() {
      return {
        password: [v => !!v || this.$t('login.password.error')],
      };
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        const { password } = this;

        this.$emit('submit', {
          password,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  padding-top: 1px;
}

.submit {
  width: 120px;
  margin-top: 35px;
}
</style>
